import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.16_@babel+core@7.25.9_@playwright+test@1.48.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.16_@babel+core@7.25.9_@playwright+test@1.48.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.16_@babel+core@7.25.9_@playwright+test@1.48.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.16_@babel+core@7.25.9_@playwright+test@1.48.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/buy-women-built.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/get-the-gloss.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/user.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/logo/full-logo-gradient.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/FooterReviewsBadgeRibbon.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Sharing.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/vercel/path0/src/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/vercel/path0/src/components/ui/separator.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/features/blog/product-recommendation/product-recommendation.tsx");
